
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"28","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","transform":"translate(3 2)"}},[_c('circle',{attrs:{"cx":"11.5","cy":"11.5","r":"10.75","stroke":"#FAB4CD","stroke-width":"1.5"}}),_c('circle',{attrs:{"cx":"11.5","cy":"11.5","r":"7.25","fill":"#FFF","stroke":"#000","stroke-width":"1.5"}}),_c('circle',{attrs:{"cx":"11.5","cy":"11.5","r":"3.75","stroke":"#FAB4CD","stroke-width":"1.5"}}),_c('g',{attrs:{"fill-rule":"nonzero"}},[_c('path',{attrs:{"fill":"#FFF","fill-rule":"evenodd","stroke":"#000","stroke-linejoin":"square","d":"M11.448 11.251l.055.01a.33.33 0 01.238.237.323.323 0 01-.004.17h0L8.797 22.01a.322.322 0 01-.113.173.34.34 0 01-.205.066.326.326 0 01-.174-.05.326.326 0 01-.118-.136h0l-1.55-3.227-3.339 3.34a.997.997 0 01-1.414 0h0l-1.06-1.061a.996.996 0 010-1.414h0l3.338-3.34-3.226-1.549a.322.322 0 01-.144-.129.334.334 0 01-.04-.194h0l10.58-3.226a.324.324 0 01.171-.004z"}}),_c('path',{attrs:{"stroke":"#FFF","d":"M11.058 10.302a1.317 1.317 0 011.302.338 1.317 1.317 0 01.34 1.301h0L9.758 22.285c-.086.303-.26.536-.474.698a1.343 1.343 0 01-1.514.064 1.316 1.316 0 01-.486-.55h0l-.938-1.955-2.342 2.341c-.39.39-.902.586-1.414.586a1.994 1.994 0 01-1.414-.586h0l-1.06-1.06A1.993 1.993 0 01-.47 20.41c0-.512.196-1.024.586-1.414h0l2.342-2.342-1.955-.938a1.31 1.31 0 01-.748-1.31c.028-.32.17-.63.414-.858h0z"}})])])])
          )
        }
      }
    